import { SupervisedApplicationOption } from '../models/supervised-application/supervised-application';

/*
 * IPS habilitadas para la aplicación supervisada de medicamentos (EPS Sanitas).
 * Si luego se obtienen de base de datos, solo cambia
 * SupervisedApplicationService.getIps(); el componente no depende de esta constante.
 */
export const SUPERVISED_APPLICATION_IPS: SupervisedApplicationOption[] = [
  { code: '1', name: 'CAYRE SEDE AMERICAS' },
  { code: '2', name: 'CAYRE SEDE PONTEVEDRA' },
  { code: '3', name: 'CENTRO DE CIRUGIA MINIMA INVASIVA SAS' },
  { code: '4', name: 'CENTRO DE INVESTACION EN REUMATOLOGIA Y ESPECIALIDADES MEDICAS SAS CIREEM SAS' },
  { code: '5', name: 'CLINICA UNIVERSITARIA COLOMBIA' }
];

export const SUPERVISED_APPLICATION_DOCUMENT_TYPES: SupervisedApplicationOption[] = [
  { code: 'CC', name: 'Cédula de Ciudadanía' },
  { code: 'CE', name: 'Cédula de Extranjería' },
  { code: 'PE', name: 'Permiso Especial de Permanencia' },
  { code: 'TI', name: 'Tarjeta de Identidad' },
  { code: 'CD', name: 'Carné Diplomático' },
  { code: 'PA', name: 'Pasaporte' },
  { code: 'RC', name: 'Registro Civil' }
];

export const SUPERVISED_APPLICATION_ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
export const SUPERVISED_APPLICATION_ALLOWED_EXTENSIONS = ['png', 'jpeg', 'jpg', 'pdf'];

// Debe coincidir con supervised.application.max-file-size de MscOrders (750KB).
// Las fotos más pesadas se comprimen en el navegador hasta este tamaño.
export const SUPERVISED_APPLICATION_MAX_FILE_SIZE = 750000;
export const SUPERVISED_APPLICATION_MAX_FILE_SIZE_LABEL = '750KB';
